export enum TypeError {
    ERROR = 0,
    Message = 1
  }
  